import * as actions from './actions';

import { Action, TalentSearchJobV2 } from '../../types';

type InitialState = TalentSearchJobV2 | null;

const initialState: InitialState = null;

export default (state: InitialState = initialState, action: Action) => {
  switch (action.type) {
    case actions.UPDATE_JOB_DETAILS: {
      const { jobDetails } = action.value;
      return {
        ...state,
        ...jobDetails,
      };
    }

    case actions.CLEAR_JOB_DETAILS: {
      return action.value;
    }

    default:
      return state;
  }
};
